module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-levelbar"
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('div', {
      key: item.path,
      staticStyle: {
        "float": "left",
        "margin-left": "20px"
      }
    }, [(index == _vm.levelList.length - 1) ? _c('span', {
      staticClass: "no-redirect"
    }, [_vm._v(_vm._s(item.name) + " ")]) : _vm._e(), _vm._v(" "), (item.redirect === "noredirect" && index != _vm.levelList.length - 1) ? _c('span', {
      staticClass: "no-redirect"
    }, [_vm._v(_vm._s(item.name) + "    >")]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0d45aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Levelbar.vue
// module id = 289
// module chunks = 48